import React, { useEffect, useState } from 'react'
import './LoginPage.css'
import {
  LoginForm,
  loginFormConstraints,
  LoginPageProps
} from './LoginPage.types'
import validate from 'validate.js'
import { inject } from 'mobx-react'
import { GENERAL_STORE, USER_STORE } from 'store'
import { withAlert } from 'react-alert'
import { observer } from 'mobx-react-lite'
import { LoginPage as LoginPageUI } from '@touche-lts/panel-ui/dist/components/pages/login-page'
import ReCAPTCHA from 'react-google-recaptcha';
import { RE_CAPTCHA_SITE_KEY } from 'config/environment'

const LoginPageComponent = (props: LoginPageProps) => {
  const {
    [GENERAL_STORE]: { alert },
    [USER_STORE]: { requestLogin, socialLogin, getGoogleAuthUrl, getMicrosoftAuthUrl, /* getAppleAuthUrl */ },
    alert: reactAlert
  } = props

  const [formState, setFormState] = useState<LoginForm>({
    emailAddress: '',
    password: '',
    toucheBackofficeLogin: true,
    rememberMe: false,
    reCaptchaToken: ''
  })

  function handleRemember (rememberMe: boolean): void {
    setFormState({
      ...formState,
      rememberMe
    })
  }

  function handleReCaptcha (token:string):void {
    setFormState({
      ...formState,
      reCaptchaToken: token
    })
  }

  const handleGoogleLogin = async () => {
    localStorage.setItem('oauth_provider', 'google')
    const data = await getGoogleAuthUrl()
    if (data?.url) {
      window.location.href = data.url
    }
  }

  const handleMicrosoftLogin = async () => {
    localStorage.setItem('oauth_provider', 'microsoft')
    const data = await getMicrosoftAuthUrl()
    if (data?.url) {
      window.location.href = data.url
    }
  }

  // const handleAppleLogin = async () => {
  //   localStorage.setItem('oauth_provider', 'apple')
  //   const data = await getAppleAuthUrl()
  //   if (data?.url) {
  //     window.location.href = data.url
  //   }
  // }

  // Handle OAuth callback
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.substring(1))
    const idToken = params.get('id_token')

    if (idToken) {
      const provider = localStorage.getItem('oauth_provider') || 'google'
      socialLogin(provider, idToken)
      localStorage.removeItem('oauth_provider')
      window.history.replaceState(null, null, window.location.pathname)
    }
  }, [socialLogin])

  useEffect(() => {
    if (alert.counter > 0) {
      reactAlert[alert.type](alert.message)
    }
    // eslint-disable-next-line
  }, [alert.counter])

  return (
    <LoginPageUI
      emailAddressValue={formState.emailAddress}
      onEmailAddressChange={emailAddress =>
        setFormState(s => ({ ...s, emailAddress }))
      }
      passwordValue={formState.password}
      onPasswordChange={password => setFormState(s => ({ ...s, password }))}
      loginButtonProps={{
        disabled: validate(formState, loginFormConstraints),
        onClick: () => requestLogin(formState),
        children: 'Log in'
      }}
      onRememberChange={handleRemember}
      onGoogleLogin={handleGoogleLogin}
      onMicrosoftLogin={handleMicrosoftLogin}
      // onAppleLogin={handleAppleLogin}
      ReCaptchaComponent={
        <div style={{ marginTop: '1rem', marginBottom: '1rem', marginInlineEnd: 'auto' }}>
          <ReCAPTCHA
            sitekey={RE_CAPTCHA_SITE_KEY}
            onChange={handleReCaptcha}
            theme='light'
          />
        </div>
      }
    />
  )
}

const LoginPage = withAlert()(
  inject(GENERAL_STORE, USER_STORE)(observer(LoginPageComponent))
)
export { LoginPage }
